import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import priceService from "./priceService";

export const getPrices = createAsyncThunk(
  "price/get-prices",
  async (params, thunkAPI) => {
    try {
      return await priceService.getPrices(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getPrice = createAsyncThunk(
  "price/get-price",
  async (data, thunkAPI) => {
    try {
      return await priceService.getPrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createPrice = createAsyncThunk(
  "price/create-price",
  async (data, thunkAPI) => {
    try {
      return await priceService.createPrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updatePrice = createAsyncThunk(
  "price/update-price",
  async (data, thunkAPI) => {
    try {
      return await priceService.updatePrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deletePrice = createAsyncThunk(
  "price/delete-price",
  async (data, thunkAPI) => {
    try {
      return await priceService.deletePrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updatePriceStatus = createAsyncThunk(
  "customer/update-price-status",
  async (data, thunkAPI) => {
    try {
      return await priceService.updatePriceStatus(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  prices: [],
  total: 0,
  priceEntryCount: 0,
  price: {},
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updating: false,
  isUpdateSuccess: false,
  creating: false,
  isCreateSuccess: false,
  isUpdateStatusSuccess: false,
};
export const priceSlice = createSlice({
  name: "price",
  initialState,
  reducers: {
    initPrice: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
      state.updating = false;
      state.isUpdateSuccess = false;
      state.creating = false;
      state.isCreateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPrices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPrices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.prices = action.payload.prices;
        state.total = action.payload.priceCount;
        state.isCreateSuccess = false;
        state.isUpdateSuccess = false;
      })
      .addCase(getPrices.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createPrice.pending, (state, action) => {
        state.creating = true;
        state.isCreateSuccess = false;
      })
      .addCase(createPrice.rejected, (state, action) => {
        state.isError = true;
        state.creating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(createPrice.fulfilled, (state, action) => {
        state.price = action.payload;
        state.creating = false;
        state.isCreateSuccess = true;
      })
      .addCase(updatePrice.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updatePrice.rejected, (state, action) => {
        state.isError = true;
        state.message = action.payload.response.data.message[0];
        state.updating = false;
      })
      .addCase(updatePrice.fulfilled, (state, action) => {
        state.price = action.payload;
        state.updating = false;
        state.isUpdateSuccess = true;
      })
      .addCase(updatePriceStatus.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
        const { id, data } = action.meta.arg;
        state.prices = state.prices.map((customer) =>
          customer.id === id ? { ...customer, ...data } : customer);
      })
      .addCase(updatePriceStatus.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(updatePriceStatus.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
      })

      .addCase(deletePrice.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
      })
      .addCase(deletePrice.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(deletePrice.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
        // Assuming action.payload contains the id of the deleted price
        const deletedId = action.meta.arg.id; // Or whatever your payload structure is    
        // Remove the price from the state
        state.prices = state.prices.filter(
          (customer) => customer.id !== deletedId
        );
      })

      .addCase(getPrice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPrice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.price = action.payload;
      })
      .addCase(getPrice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
  },
});
export default priceSlice.reducer;
export const { initPrice } = priceSlice.actions;